import LinearActivityBar from 'components/ProgressBar/LinearActivityBar';
import i18next from 'i18next';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import avatar5 from '../../assets/img/avatar_5.svg';
import arrowWhiteIcon from '../../assets/img/icons/arrow_right_white.svg';
import ComponentCircleLoader from '../../components/Loaders/ComponentCircleLoader';
import NoDataComponent from '../../components/NoDataComponent/NoDataComponent';
import AssigneeTooltip from '../../components/Tooltip/AssigneeTooltip';
import {
  TableItem,
  TableRowAndBudgetCollapseContainer,
} from '../../styledComponents/ProjectsNew';
import {
  CommonFlex,
  Container,
  TableText,
} from '../../styledComponents/common';
import { ItemsTransactionsReportTable } from '../../styledComponents/itemsTransactionsReport';
import { ExpandIcon, ProjectExpandButton } from '../Projects/projectsStyles';
import TaskEvidence from '../Tasks/TaskDetails/taskEvidence';
import { AssigneeRoundImg, CollapseSection } from '../Tasks/tasksStyles';

const ItemsTransactionsReportList = ({
  isLoading,
  itemsTransactionsList,
  selectedTransaction,
  selectTransaction,
}) => {
  const { t } = useTranslation();
  const [list, setList] = useState([]);

  useEffect(() => {
    if (itemsTransactionsList && itemsTransactionsList.length > 0) {
      const updatedList = itemsTransactionsList.map(transaction => ({
        ...transaction,
        task_code: transaction.task_code,
        public_zone_name: transaction.public_zone_name,
        office: transaction.office,
        assignees: transaction.assignees,
        created_at: transaction.created_at,
        item_name: transaction.item_name,
        current_quantity: transaction.current_quantity,
        quantity: transaction.quantity,
        employee_note: transaction.employee_note,
        evidences: transaction.evidences || [],
        receive_or_decrease: transaction.current_quantity - transaction.quantity < 0 ? 'Decrease' : 'Receive',
        required_quantity: transaction.required_quantity,
      }));
      setList(updatedList);
    } else {
      setList([]);
    }
  }, [itemsTransactionsList]);

  const handleExpandClick = transaction => {
    if (selectedTransaction && selectedTransaction.id === transaction.id) {
      selectTransaction(null);
    } else {
      selectTransaction(transaction);
    }
  };

  return (
    <Container style={{ paddingBottom: '20px', overflowX: 'auto' }}>
      {isLoading ? (
        <ComponentCircleLoader />
      ) : list && list.length > 0 ? (
        <>
          <ItemsTransactionsReportTable heading transaction={true}>
            <TableItem>
              <TableText>{t('task_code')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('public_zone')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('office')}</TableText>
            </TableItem>
            {/* <TableItem>
              <TableText>{t('assignee')}</TableText>
            </TableItem> */}
            <TableItem>
              <TableText>{t('date_and_time')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('item_name')}</TableText>
            </TableItem>
            {/* <TableItem>
              <TableText>{t('quantity')}</TableText>
            </TableItem> */}
            <TableItem>
              <TableText>{t('receive_or_decrease')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('required_quantity')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('current_quantity')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('remaining')}</TableText>
            </TableItem>
            <TableItem>
              <TableText>{t('status')}</TableText>
            </TableItem>
            <TableItem />
          </ItemsTransactionsReportTable>
          {list.map(transaction => (
            <TableRowAndBudgetCollapseContainer key={transaction.id}>
              <ItemsTransactionsReportTable transaction={true}>
                <TableItem>
                  <TableText
                    hoverPointer
                    hoverUnderline
                    name
                    fontWeight={
                      selectedTransaction &&
                      selectedTransaction.id === transaction.id &&
                      '600'
                    }
                    onClick={() => selectTransaction(transaction)}
                  >
                    {transaction.task_code}
                  </TableText>
                </TableItem>
                <TableItem>
                  <TableText name>{transaction.public_zone_name}</TableText>
                </TableItem>
                <TableItem>
                  <TableText name>{transaction.office}</TableText>
                </TableItem>
                {/* <TableItem>
                  {transaction.assignees.id ? (
                    <AssigneeRoundImg
                      image={transaction.assignees.avatar || avatar5}
                    >
                      <AssigneeTooltip
                        toolTipText={`${
                          transaction.assignees.first_name
                            ? ` ${transaction.assignees.first_name}`
                            : ``
                        }${
                          transaction.assignees.last_name
                            ? ` ${transaction.assignees.last_name}`
                            : ``
                        }${
                          transaction.assignees.name
                            ? ` ${transaction.assignees.name}`
                            : ``
                        }`}
                        phone={transaction.assignees.phone}
                        top="-60px"
                        left="-55px"
                      />
                    </AssigneeRoundImg>
                  ) : null}
                </TableItem> */}
                <TableItem>
                  <TableText name>
                    {moment(transaction.created_at).format('DD/MM/YYYY HH:mm')}
                  </TableText>
                </TableItem>
                <TableItem>
                  <TableText name>{transaction.item_name}</TableText>
                </TableItem>
                {/* <TableItem>
                  <TableText name>{transaction.quantity}</TableText>
                </TableItem> */}
                <TableItem>
                  <TableText name>{transaction.sub_task_type.charAt(0).toUpperCase() + transaction.sub_task_type.slice(1)} {transaction.reason !== ""  ? `- ${transaction.reason}` : ""}</TableText>
                </TableItem>
                <TableItem>
                  <TableText name>{transaction.required_quantity}</TableText>
                </TableItem>
                <TableItem>
                  <TableText name>{transaction.current_quantity}</TableText>
                </TableItem>
                <TableItem>
                  <TableText
                    style={{
                      color:
                        transaction.remaining < 0
                          ? 'red'
                          : 'inherit',
                    }}
                  >
                    {transaction.remaining}
                  </TableText>
                </TableItem>
                <TableItem>
                  <TableText name>{transaction.approval_status ? transaction.approval_status.charAt(0).toUpperCase() + transaction.approval_status.slice(1) : 'Pending'}</TableText>
                </TableItem>
                <TableItem alignContent="start">
                  <CommonFlex gap="12px" wrap="wrap">
                    <ProjectExpandButton
                      margin="0"
                      onClick={() => handleExpandClick(transaction)}
                    >
                      <ExpandIcon
                        src={arrowWhiteIcon}
                        alt=""
                        open={
                          selectedTransaction &&
                          selectedTransaction.id === transaction.id
                        }
                      />
                    </ProjectExpandButton>
                  </CommonFlex>
                </TableItem>
              </ItemsTransactionsReportTable>
              <CollapseSection
                open={selectedTransaction?.id === transaction.id}
              >
                <Container padding="30px" borderColor="#977C70" margin="20px">
                  <TaskEvidence evidences={transaction.evidences} />
                </Container>
              </CollapseSection>
            </TableRowAndBudgetCollapseContainer>
          ))}
        </>
      ) : (
        <NoDataComponent
          title={t('no_transactions_found')}
          padding="5vh 0"
          imageHeight="140px"
        />
      )}
    </Container>
  );
};

export default ItemsTransactionsReportList;
